document.addEventListener("product:variant-change", function (event) {
  const variant = event.detail.variant;
  if (!variant) return;
  toggleOutOfStockBlocks(variant.available);
});

function toggleOutOfStockBlocks(isAvailable) {
  if (isAvailable) {
    const elementsToShow = document.querySelectorAll(
      "[data-hide-if-not-available]"
    );

    const elementsToHide = document.querySelectorAll(
      "[data-show-if-not-available]"
    );

    if (elementsToHide && elementsToHide.length > 0) {
      elementsToHide.forEach((el) => {
        if (el.dataset.visible === "false") return;
        el.classList.add("hidden");
        el.dataset.visible = "false";
      });
    }

    if (elementsToShow && elementsToShow.length > 0) {
      elementsToShow.forEach((el) => {
        if (el.dataset.visible === "true") return;
        el.classList.remove("hidden");
        el.dataset.visible = "true";
      });
    }
  } else if (isAvailable) {
    const elementsToHide = document.querySelectorAll(
      "[data-hide-if-not-available]"
    );
    const elementsToShow = document.querySelectorAll(
      "[data-show-if-not-available]"
    );
    if (elementsToHide && elementsToHide.length > 0) {
      elementsToHide.forEach((el) => {
        if (el.dataset.visible === "false") return;
        el.classList.add("hidden");
        el.dataset.visible = "false";
      });
    }
    if (elementsToShow && elementsToShow.length > 0) {
      elementsToShow.forEach((el) => {
        if (el.dataset.visible === "true") return;
        el.classList.remove("hidden");
        el.dataset.visible = "true";
      });
    }
  }
}